import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { InventoryListParams } from '../api/inventory-api';
import { INVENTORY_FILTER_FIELDS, INVENTORY_SORTS } from '../components/inventory-filters';

/**
 * URL search params of the inventory list; mirrors GET /admin/v1/stores/{storeId}/inventory. No
 * `locationId` means the store's default location.
 */
export const inventoryListSearchSchema = indexSearchSchema(INVENTORY_FILTER_FIELDS, {
  sort: INVENTORY_SORTS,
});

export type InventoryListSearch = z.infer<typeof inventoryListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function inventoryListParams(search: InventoryListSearch): InventoryListParams {
  return listParams(search, INVENTORY_FILTER_FIELDS);
}
